import { render, staticRenderFns } from "./MspWorkout.vue?vue&type=template&id=112046fc"
import script from "./MspWorkout.vue?vue&type=script&lang=js"
export * from "./MspWorkout.vue?vue&type=script&lang=js"
import style0 from "./MspWorkout.vue?vue&type=style&index=0&id=112046fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports